import { type ReactNode } from "react";
import { cn } from "@/lib/utils";

/** 1720px max-width content shell */
export function Container({
  children,
  className,
  size = "default",
}: {
  children: ReactNode;
  className?: string;
  size?: "default" | "wide" | "narrow";
}) {
  return (
    <div
      className={cn(
        "container-x mx-auto",
        size === "narrow" && "max-w-[1100px]",
        size === "wide" && "max-w-[1680px]",
        className,
      )}
    >
      {children}
    </div>
  );
}

/** Section with vertical rhythm + optional id anchor */
export function Section({
  id,
  children,
  className,
  bleed = false,
}: {
  id?: string;
  children: ReactNode;
  className?: string;
  bleed?: boolean;
}) {
  return (
    <section id={id} className={cn(!bleed && "section-pad", "relative", className)}>
      {children}
    </section>
  );
}
